import { AbstractApi } from ".";

class FilesApi extends AbstractApi {
    transcodeUrl = '/api/files/transcribe';

    async calculate(files) {
        let payload = files;
        if (typeof files == 'string') {
            payload = { files: [files] };
        }

        return await this.post(this.transcodeUrl, payload);
    }

    async transcribe(files, payload = {}) {
        payload = { ...payload, ...files };
        if (typeof files == 'string') {
            payload = { files: [files] };
        }

        // Нормализация и фильтрация "мусорных" id перед отправкой.
        // Это защищает от случаев, когда UI может прокинуть плейсхолдер transcription_id < 0
        // или некорректный набор items при оплате/очереди.
        if (payload && Array.isArray(payload.files)) {
            payload.files = payload.files
                .map((id) => Number(id))
                .filter((id) => Number.isFinite(id) && id > 0);
        } else if (payload && (typeof payload.files === 'string' || typeof payload.files === 'number')) {
            const id = Number(payload.files);
            payload.files = (Number.isFinite(id) && id > 0) ? [id] : [];
        }

        if (payload && Array.isArray(payload.files) && payload.files.length === 0) {
            throw new Error('No valid files to transcribe');
        }

        payload.addToQueue = 1;

        return await this.post(this.transcodeUrl, payload);
    }

    async payAndTranscribe(files, offer, variant = null) {
        return await this.transcribe(files, { offer, variant });
    }

    async transcribeWithLanguage(filePath, language) {

        await this.transcribe({ files: [filePath], options: { 'language': language }, toLanguage: 1 });
    }
}

export default new FilesApi;
